import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (err) {
      console.warn("session refresh failed:", err?.response?.status);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // If returning from Emergent OAuth callback, skip /me check; let AuthCallback set state first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    refresh();
  }, [refresh]);

  const loginJwt = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("crash_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const registerJwt = async (email, password, name) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    localStorage.setItem("crash_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const loginGoogleSession = async (session_id) => {
    const { data } = await api.post("/auth/google/session", { session_id });
    localStorage.setItem("crash_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      console.warn("logout request failed (ignored):", err?.message);
    }
    localStorage.removeItem("crash_token");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, refresh, loginJwt, registerJwt, loginGoogleSession, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
